import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import {
    BasketAddress,
    IPurchasingGroupResolution,
    SupplierBasket,
    TotalBasket,
} from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/ui';
import { IBudgetExceedance } from '@lib/shared/basket-service';

@Component({
    selector: 'basket-check',
    templateUrl: './basket-check.component.html',
    styleUrls: ['./basket-check.component.scss'],
    standalone: false,
})
export class BasketCheckComponent {
    @Input() deliveryAddress: BasketAddress | undefined;
    @Input() invoiceAddress: BasketAddress | undefined;
    @Input() supplierBaskets!: SupplierBasket[];
    @Input() currencyTotals: TotalBasket[] = [];
    @Input() isEditableStep!: boolean;
    @Input() priceIsZero!: boolean;
    @Input() purchaseRequisitionStatus!: boolean;
    @Input() showStepperButtons!: boolean;
    @Input() isOrderCreationAllowed!: boolean;
    // Undefined until the right is known: checkout stays disabled, but the missing-permission hint
    // only appears on an explicit deny.
    readonly isOrderCompletionAllowed = input<boolean>();
    @Input() isMobile?: boolean;
    @Input() budgetOverruns: IBudgetExceedance[] | null = [];
    @Input() companyCodeId: string | null = null;
    @Input() resolvedPurchasingGroups: readonly IPurchasingGroupResolution[] = [];
    // Defaults to false so the summary never shows purchasing groups unless the tenant setting
    // (shownInOrderProcess) is explicitly forwarded as true, matching the Step 1 gating.
    @Input() purchasingGroupVisible = false;

    @Output() previousClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() ordered: EventEmitter<void> = new EventEmitter<void>();
    @Output() validityChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() demanded: EventEmitter<void> = new EventEmitter<void>();

    onCheckout(): void {
        if (!this.hasInvoiceAddress()) {
            this.validityChanged.next(false);
            return;
        }
        this.validityChanged.next(true);
        this.ordered.emit();
    }

    onDemand(): void {
        this.demanded.emit();
    }

    onClickPrevious(): void {
        this.previousClicked.emit();
    }

    hasInvoiceAddress(): boolean {
        return !!this.invoiceAddress;
    }
}
